const clone = (value) => {
  if (value === undefined) return value;
  return JSON.parse(JSON.stringify(value));
};

const getSectionKey = (section = {}) => section.id || section.key;

export const normalizeEmergencyProcedure = (procedure = {}) => {
  const sourceSections = Array.isArray(procedure.sections)
    ? procedure.sections
    : (procedure.sections && typeof procedure.sections === "object"
      ? Object.keys(procedure.sections).map((key) => procedure.sections[key])
      : []);
  const sections = sourceSections.reduce((result, section) => {
    const key = getSectionKey(section);
    if (!key) return result;

    const data = clone(section.data) || {};
    result[key] = {
      ...clone(section),
      data: {
        ...data,
        toggle: data.toggle === undefined ? 1 : Number(data.toggle)
      }
    };
    return result;
  }, {});

  return {
    ...clone(procedure),
    toggle: procedure.toggle === undefined ? 1 : Number(procedure.toggle),
    section_order: Array.isArray(procedure.section_order)
      ? [...procedure.section_order]
      : sourceSections.map(getSectionKey).filter(Boolean),
    sections
  };
};

export const normalizeEmergencyProcedures = (procedures = []) => (
  Array.isArray(procedures) ? procedures.map(normalizeEmergencyProcedure) : []
);

export const serializeEmergencyProcedure = (procedure = {}, originalProcedure = {}) => {
  const result = {
    ...clone(originalProcedure),
    ...clone(procedure)
  };
  delete result.disabled;
  const sections = procedure.sections && typeof procedure.sections === "object"
    ? procedure.sections
    : {};
  const sourceSections = Array.isArray(originalProcedure.sections) ? originalProcedure.sections : [];
  const sourceSectionMap = sourceSections.reduce((resultMap, section) => {
    const key = getSectionKey(section);
    if (key) resultMap[key] = section;
    return resultMap;
  }, {});
  const order = Array.isArray(procedure.section_order)
    ? procedure.section_order
    : Object.keys(sections);
  const sectionKeys = [...order, ...Object.keys(sections), ...Object.keys(sourceSectionMap)]
    .filter((key, index, keys) => key && keys.indexOf(key) === index);

  result.sections = sectionKeys.map((key) => {
    const section = {
      ...(clone(sourceSectionMap[key]) || {}),
      ...(clone(sections[key]) || {})
    };
    const data = {
      ...(clone(sourceSectionMap[key] && sourceSectionMap[key].data) || {}),
      ...(clone(sections[key] && sections[key].data) || {})
    };
    return {
      ...section,
      id: section.id || key,
      data: {
        ...data,
        toggle: data.toggle === undefined ? 1 : Number(data.toggle)
      },
      toggle: data.toggle === undefined ? 1 : Number(data.toggle)
    };
  });
  result.section_order = sectionKeys;
  result.toggle = procedure.toggle === undefined ? 1 : Number(procedure.toggle);
  return result;
};

export const serializeEmergencyProcedures = (procedures = [], originals = []) => (
  (Array.isArray(procedures) ? procedures : []).map((procedure, index) => (
    serializeEmergencyProcedure(procedure, originals[index] || {})
  ))
);

export default normalizeEmergencyProcedures;
